<template>
  <div
    class="
      d-flex
      justify-center
      align-center
    "
  >
    <span v-if="total">{{ total }} items</span>
    <v-divider
      v-if="total"
      class="mx-6"
      vertical
    ></v-divider>

    <v-pagination
      circle
      :total-visible="7"
      :value="value"
      @input="$emit('input', $event || null)"
      :length="pageCount"
      style="width: auto"
    ></v-pagination>

    <v-divider
      class="mx-6"
      vertical
    ></v-divider>

    <span class="mr-3">Go to page:</span>

    <v-text-field
      type="number"
      :value="value"
      @input="$emit('input', parseInt($event, 10))"
      :min="1"
      :max="pageCount"
      hide-details
      dense
      outlined
      style="max-width: 85px"
    ></v-text-field>

    <v-divider
      class="mx-6"
      vertical
    ></v-divider>

    <span class="mr-3">Items per page:</span>

    <v-select
      :items="[25, 50, 100, 200]"
      :value="itemsPerPage"
      @input="$emit('update:itemsPerPage', $event)"
      style="max-width: 100px"
      dense
      outlined
      hide-details
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    value: { // v-model binding
      type: Number
    },
    pageCount: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    itemsPerPage: {
      type: Number,
      default: 25
    }
  }
}
</script>
